import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M7.08 23.724h4.742v-9.42H7.08z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M7.08 14.918h4.74V5.271c0-.748-.606-1.355-1.354-1.355h-2.03c-.749 0-1.355.607-1.355 1.355v9.646Z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M14.532 23.724h4.74v-6.48h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M14.532 18.918h4.74v-7.646c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M21.983 23.726h4.741v-8.128h-4.741z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M21.983 15.918h4.74V8.271c0-.748-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked;
